export default function OrderPrintIcon() {
  return (
    <svg viewBox="0 0 16.67 20.76" xmlns="https://www.w3.org/2000/svg">
      <path
        data-name="Path 519"
        d="M16.05 0H4.31a.63.63 0 0 0-.63.63v1.3H2.47a.63.63 0 0 0-.63.62v1.3H.63a.63.63 0 0 0-.63.62v15.66a.63.63 0 0 0 .63.63h11.74a.64.64 0 0 0 .62-.63v-1.3h1.21a.63.63 0 0 0 .63-.63v-1.29H16a.63.63 0 0 0 .63-.62V.62a.62.62 0 0 0-.58-.62m-4.31 19.5H1.25V5.1h10.49zm.63-15.65H3.1v-.67h10.48v14.4H13V4.47a.63.63 0 0 0-.63-.62m1.85-1.93H4.94v-.66h10.48v14.4h-.59V2.55a.63.63 0 0 0-.62-.63"
      />
      <path
        data-name="Path 520"
        d="M3.11 12.76h6.7v-.14.14a.63.63 0 1 0 0-1.26h-6.7a.63.63 0 1 0 0 1.26"
      />
      <path
        data-name="Path 521"
        d="M3.11 15.33h6.7v-.14.14a.64.64 0 0 0 .64-.63.64.64 0 0 0-.64-.64h-6.7a.64.64 0 0 0-.64.64.63.63 0 0 0 .64.63"
      />
      <path
        data-name="Path 522"
        d="M3.11 17.85h6.7v-.14.14a.63.63 0 1 0 0-1.26h-6.7a.63.63 0 1 0 0 1.26"
      />
      <path
        data-name="Path 523"
        d="M6.38 10.25a1.69 1.69 0 1 0-1.69-1.69 1.71 1.71 0 0 0 1.69 1.69"
      />
    </svg>
  );
}
